import { Action } from '../../Actions/hooks/actionHooks';
import { GetIncidentActionResponse } from '../../Actions/hooks/incidentActionHooks';
import { Objective } from '../hooks/objectiveHooks';
import { IncidentObjective } from '../hooks/incidentObjectiveHooks';
import { Strategy } from '../hooks/strategyHooks';
import { IncidentStrategy } from '../hooks/incidentStrategyHooks';
import { Tactic } from '../hooks/tacticHooks';
import { IncidentTactic } from '../hooks/incidentTacticHooks';
import { Coms } from '../hooks/comsHooks';
import { IncidentComs } from '../hooks/incidentComsHooks';
import { Hospital } from '../hooks/hospitalsHooks';
import { IncidentHospital } from '../hooks/incidentHospitalsHooks';
import { MedicalAidStation } from '../hooks/medicalAidStationsHooks';
import { IncidentMedicalAidStation } from '../hooks/incidentMedicalAidStationsHooks';
import { MedicalTransportation } from '../hooks/medicalTransportationHooks';
import { IncidentMedicalTransportation } from '../hooks/incidentMedicalTransportationHooks';
import { INCIDENT, IapScope } from '../ICSConstants';

export const isIncidentAction = (
  editedEntity: GetIncidentActionResponse | Action,
  scope: IapScope
): editedEntity is GetIncidentActionResponse =>
  scope === INCIDENT && 'action_id' in editedEntity;

export const isIncidentObjective = (
  editedEntity: IncidentObjective | Objective,
  scope: IapScope
): editedEntity is IncidentObjective =>
  scope === INCIDENT && 'objective_id' in editedEntity;

export const isIncidentStrategy = (
  editedEntity: IncidentStrategy | Strategy,
  scope: IapScope
): editedEntity is IncidentStrategy =>
  scope === INCIDENT && 'strategy_id' in editedEntity;

export const isIncidentTactic = (
  editedEntity: IncidentTactic | Tactic,
  scope: IapScope
): editedEntity is IncidentTactic =>
  scope === INCIDENT && 'tactic_id' in editedEntity;

export const isIncidentComs = (
  editedEntity: IncidentComs | Coms,
  scope: IapScope
): editedEntity is IncidentComs =>
  scope === INCIDENT && 'coms_id' in editedEntity;

export const isIncidentHospital = (
  editedEntity: IncidentHospital | Hospital,
  scope: IapScope
): editedEntity is IncidentHospital =>
  scope === INCIDENT && 'hospital_id' in editedEntity;

export const isIncidentMedicalAidStation = (
  editedEntity: IncidentMedicalAidStation | MedicalAidStation,
  scope: IapScope
): editedEntity is IncidentMedicalAidStation =>
  scope === INCIDENT && 'medical_aid_station_id' in editedEntity;

export const isIncidentMedicalTransportation = (
  editedEntity: IncidentMedicalTransportation | MedicalTransportation,
  scope: IapScope
): editedEntity is IncidentMedicalTransportation =>
  scope === INCIDENT && 'transportation_id' in editedEntity;
